<template>
  <b-modal
    :visible="show"
    title="Confirm hold"
    centered
    no-close-on-backdrop
    @hide="$emit('cancel')"
  >
    <div v-if="hold">
      <p class="mb-3">
        You are about to <strong>confirm</strong> this hold. This will debit the
        wallet permanently and create a transaction.
      </p>
      <dl class="row mb-0">
        <dt class="col-5 text-muted">Hold ID</dt>
        <dd class="col-7 text-break">{{ hold.hold_id }}</dd>
        <dt class="col-5 text-muted">Wallet ID</dt>
        <dd class="col-7 text-break">{{ hold.wallet_id }}</dd>
        <dt class="col-5 text-muted">Amount</dt>
        <dd class="col-7">{{ formatAmount(hold.amount) }} {{ hold.currency_code }}</dd>
      </dl>
    </div>

    <template #modal-footer>
      <b-button variant="outline-secondary" @click="$emit('cancel')">Cancel</b-button>
      <!-- Confirm is the irreversible "move money" action — styled danger to stand
           apart from the Reverse modal's warning-styled primary button. -->
      <b-button variant="danger" @click="$emit('confirm')">Confirm hold</b-button>
    </template>
  </b-modal>
</template>

<script>
import { formatAmount } from "@/utils/holds/formatters";

export default {
  name: "HoldConfirmModal",
  props: {
    show: { type: Boolean, default: false },
    hold: { type: Object, default: null },
  },
  methods: {
    formatAmount,
  },
};
</script>
